export default class BezierNode {
    constructor(coords=[], handle=null, handle2=null) {
        this.coords=coords;
        this.handle=handle;
        this.handle2=handle2;
    }
}